import cap from '../lib/capsdk'

export default class {
  static all() {
    return cap.requestA('session.getUserData', { sess_key: cap.sess_key })
  }
}
